import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';
type ArrowForwardIosProps = IconComponentBaseProps;

export const ArrowForwardIos = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: ArrowForwardIosProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7277_5903"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7277_5903)">
        <path
          d="M15.1865 12L7.47125 4.2845C7.32375 4.13717 7.251 3.96 7.253 3.753C7.25483 3.54583 7.3295 3.36858 7.477 3.22125C7.62433 3.07375 7.80158 3 8.00875 3C8.21575 3 8.393 3.07375 8.5405 3.22125L16.177 10.8635C16.3385 11.025 16.4564 11.2051 16.5308 11.4038C16.6051 11.6026 16.6423 11.8013 16.6423 12C16.6423 12.1987 16.6051 12.3974 16.5308 12.5963C16.4564 12.7949 16.3385 12.975 16.177 13.1365L8.5345 20.7788C8.38717 20.9263 8.21092 20.999 8.00575 20.997C7.80058 20.9952 7.62433 20.9205 7.477 20.773C7.3295 20.6257 7.25575 20.4484 7.25575 20.2413C7.25575 20.0343 7.3295 19.857 7.477 19.7095L15.1865 12Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
